import { parseDateISO } from '@zorro/shared/formatters';

export function findLatestPeriod<T extends { effectiveFrom: string }>(
  periods: T[]
): T | undefined {
  if (periods.length === 0) {
    return undefined;
  }
  return periods.reduce((prev, current) => {
    return parseDateISO(prev.effectiveFrom).isAfter(
      parseDateISO(current.effectiveFrom)
    )
      ? prev
      : current;
  });
}
